module.exports = __webpack_public_path__ + "static/media/7_of_diamonds.919ac1b5.png";